import { Theme } from '@app/theme';
import { TextAndImageSelectionField } from 'components';
import Logo from '@app/illu/Branding/FullLogoBux.svg';
import Mail from '@app/illu/Large/Mail.svg';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { QuoteInformation } from 'queries';
import { useCallback } from 'react';

const useStyles = createUseStyles((theme: Theme) => ({
  selectBlockContainer: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.marginBase * 3 + 'px',

    [theme.media.mobile]: {
      flexDirection: 'column',
    },
  },
}));

export const SourceSection = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { setFieldValue, resetForm } =
    useFormikContext<Partial<QuoteInformation>>();

  const onSourceChange = useCallback(
    (source: string) => {
      resetForm();
      setFieldValue('source', source);
    },
    [setFieldValue, resetForm],
  );

  return (
    <div className={classes.selectBlockContainer}>
      <TextAndImageSelectionField
        illustration={Logo}
        title={t('studySetup.generalSetup.source.community.title')}
        description={t('studySetup.generalSetup.source.community.description')}
        name="source"
        value="TANDEMZ"
        onChange={onSourceChange}
        trackingName="Participant Source"
      />
      <TextAndImageSelectionField
        illustration={Mail}
        title={t('studySetup.generalSetup.source.own.title')}
        description={t('studySetup.generalSetup.source.own.description')}
        name="source"
        value="CLIENT"
        onChange={onSourceChange}
        trackingName="Participant Source"
      />
    </div>
  );
};
